import { useQuery } from '@tanstack/react-query';
import { getCountriesSettings } from './getCountriesSettings';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { mockCountriesConfigurationResponse } from './mock';
import { CountriesConfigurationResponse } from './types';
import { QUERY_KEY_SETTINGS_COUNTRIES, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

type Props = {
  companyId: string
}

export function useQueryCountriesSettings(props: Props) {
  const { companyId } = props
  return useQuery<CountriesConfigurationResponse>({
    queryKey: [QUERY_KEY_SETTINGS_COUNTRIES, companyId],
    queryFn: async () => {
      if (COMPANY_API_SETTINGS_MOCKED) {
        return mockCountriesConfigurationResponse
      }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getCountriesSettings(props);
      return data;
    },
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
